import styled from 'styled-components';
import { PrimaryButton } from '../common/Button';

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  padding: 20px;
  text-align: center;
`;

export const ErrorHeading = styled.h1`
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: 16px;
`;

export const ErrorMessage = styled.p`
  color: ${({ theme }) => theme.colors.textSecondary};
  margin-bottom: 24px;
`;

export const RetryButton = PrimaryButton;
